import "./Actividad.css";
import React, { useEffect, useState } from "react";
import SeccionComentarios from "./subcomponents/SeccionComentarios";
import SeccionDocumentos from "./subcomponents/SeccionDocumentos";
import SeccionGeneral from "./subcomponents/SeccionGeneral";
import SeccionLaboral from "./subcomponents/SeccionLaboral";
import SeccionProgramas from "./subcomponents/SeccionProgramas";
import LoadingOverlay from "../0. Utilidades/LoadingOverlay";

import { BsFillPersonLinesFill } from "react-icons/bs";
import { MdWork } from "react-icons/md";
import { HiMiniAcademicCap } from "react-icons/hi2";
import { SlDocs } from "react-icons/sl";
import { GoCommentDiscussion } from "react-icons/go";
import { CiEdit } from "react-icons/ci";

function ActividadView({ actividad }) {
  const [isLoading, setIsLoading] = useState(true);
  const [actividadData, setActividadData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [activeTab, setActiveTab] = useState("info");

  useEffect(() => {
    if (actividad && actividad.nombre) {
      // Use initial data from props
      setActividadData(actividad);
      setIsLoading(false);
    } else {
      const fetchActividad = async () => {
        setIsLoading(true);
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_API}api/perfiles/actividades/${actividad.id}/`,
          );
          if (!response.ok) throw new Error("ID not found");
          const data = await response.json();
          setActividadData(data);
        } catch (error) {
          console.error("Error:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchActividad();
    }
  }, [actividad]);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      setActiveTab(hash);
    }
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      setActiveTab(hash || "info");
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  if (isLoading) return <LoadingOverlay />;

  const handleCopy = () => {
    navigator.clipboard
      .writeText(actividadData.url)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
      })
      .catch((err) => console.error("Error copying URL:", err));
  };

  // Parent can also accept the updated payload directly (no refetch)
  const handleActividadUpdated = (updatedActividad) => {
    // Option A (fast): just replace state with what backend returned
    setActividadData(updatedActividad);

    // Option B (strict): refetch to ensure it's truly fresh
    // refreshCurso();
  };

  return (
    <div id="actividad">
      <div className="actividad-card">
        <img
          src={
            actividadData.imagen ||
            "https://cdn-redmaestra-endpoint.azureedge.net/static/images/defaultcourse.png"
          }
          alt={actividad.nombre || "Default"}
        />

        <div className="actividad-card-text">
          <p>
            <strong>Nombre:</strong> {actividadData.nombre}
          </p>
          <p>
            <strong>Oficio:</strong> {actividadData.oficio}
          </p>
          <p>
            <strong>Region:</strong> {actividadData.region}
          </p>
          <p>
            <strong>Comuna:</strong> {actividadData.comuna}
          </p>
        </div>

        <div className="actividad-card-text">
          <a
            href={`/api/perfiles/editar_actividades/${actividadData.id}/`}
            className="btn btn-secondary"
          >
            <CiEdit />
          </a>
        </div>
      </div>

      {actividadData.url && (
        <div
          className="actividad-link"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginTop: "15px",
          }}
        >
          {/* "Ir a Formulario" Button */}
          <a
            href={actividadData.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "bold",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "background-color 0.3s ease, transform 0.2s ease",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#0056b3";
              e.target.style.transform = "scale(1.05)";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#007bff";
              e.target.style.transform = "scale(1)";
            }}
          >
            Ir a Formulario
          </a>

          {/* Copy URL Button */}
          <button
            onClick={handleCopy}
            style={{
              border: "solid 2px #007bff",
              backgroundColor: "white",
              color: "#007bff",
              borderRadius: "8px",
              padding: "10px 20px",
              cursor: "pointer",
              fontWeight: "bold",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease, transform 0.2s ease",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#007bff";
              e.target.style.color = "white";
              e.target.style.transform = "scale(1.05)";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#007bff";
              e.target.style.transform = "scale(1)";
            }}
          >
            📋 Copiar Link
          </button>

          {/* Copied confirmation message */}
          {copied && (
            <span style={{ color: "green", fontWeight: "bold" }}>
              ✔ ¡Copiado!
            </span>
          )}
        </div>
      )}

      <div className="actividad-tabs">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "info" ? "active" : ""}`}
              onClick={() => setActiveTab("info")}
              href="#info"
            >
              <BsFillPersonLinesFill />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "laboral" ? "active" : ""}`}
              onClick={() => setActiveTab("laboral")}
              href="#laboral"
            >
              <MdWork />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "programas" ? "active" : ""}`}
              onClick={() => setActiveTab("programas")}
              href="#programas"
            >
              <HiMiniAcademicCap />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "comments" ? "active" : ""}`}
              onClick={() => setActiveTab("comments")}
              href="#comments"
            >
              <GoCommentDiscussion />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "documents" ? "active" : ""}`}
              onClick={() => setActiveTab("documents")}
              href="#documents"
            >
              <SlDocs />
            </a>
          </li>
        </ul>

        <div className="tab-content">
          {activeTab === "info" && <SeccionGeneral actividad={actividadData} />}
          {activeTab === "laboral" && (
            <SeccionLaboral actividad={actividadData} />
          )}
          {activeTab === "programas" && (
            <SeccionProgramas actividad={actividadData} onCursoUpdated={handleActividadUpdated} />
          )}
          {activeTab === "documents" && (
            <SeccionDocumentos actividadId={actividad.id} />
          )}
          {activeTab === "comments" && (
            <SeccionComentarios actividadId={actividad.id} />
          )}
        </div>
      </div>
    </div>
  );
}

export default ActividadView;
